<template>
  <div>
    <v-expansion-panels flat tile hover v-model="categoryPanels" multiple accordion>
      <v-expansion-panel class="my-0 py-2">
        <DynamicFields v-if="sizeConf.length > 0" :config="sizeConf" :title="'Size'" :values="product.Size"
          :fillDynamic="fillDynamic" ref="sizeFields" :key="sizeKey" :dialogTitle="dialogTitle" :gender="product.Gender"
          :category="category" @toggledDynamicFields="toggledDynamicFields"></DynamicFields>
      </v-expansion-panel>

      <v-expansion-panel class="my-0 py-2">
        <DynamicFields v-if="measurementConf.length > 0" :config="measurementConf" :title="'Measurements'"
          :values="product.Measurement" :fillDynamic="fillDynamic" ref="measurementFields" :dialogTitle="dialogTitle"
          :categoryImg="categoryImg" @toggledDynamicFields="toggledDynamicFields"></DynamicFields>
      </v-expansion-panel>

      <v-expansion-panel class="my-0 py-2">
        <DynamicFields v-if="otherConf.length > 0" :config="otherConf" :title="'Other'" :values="product.Other"
          :fillDynamic="fillDynamic" ref="otherFields" :dialogTitle="dialogTitle"
          @toggledDynamicFields="toggledDynamicFields"></DynamicFields>
      </v-expansion-panel>
      <v-expansion-panel class="my-0 py-2">
        <CompositionFields :config="compositionConf" :title="'Material'" :values="product.Composition"
          :fillDynamic="fillDynamic" ref="compositionFields" :category="category" :dialogTitle="dialogTitle"
          @toggledCompositionFields="toggledCompositionFields"></CompositionFields>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import DynamicFields from "./DynamicFields.vue";
import CompositionFields from "./CompositionFields.vue";

export default {
  name: "CategoryConfigFields",
  components: {
    CompositionFields,
    DynamicFields,
  },
  props: {
    category: String,
    categories: Array,
    product: Object,
    fillDynamic: Boolean,
    dialogTitle: String,
    type: String,
  },
  data: () => ({
    compositionConf: [
      {
        fieldType: "composition",
        name: "Material",
        purpose: "Composition",
        required: true,
      },
    ],
    measurementConf: [],
    sizeConf: [],
    otherConf: [],
    categoryIdPath: "",
    categoryImg: "",
    sizeKey: 0,
    snackbar: false,
    snackbarText: "",
    categoryPanels: [],
  }),
  async mounted() {
    await this.setCategoryFields(this.category);
    if (this.type == "registration") {
      this.categoryPanels = [0];
    } else {
      this.categoryPanels = [0, 1, 2, 3];
    }
  },
  methods: {
    toggledCompositionFields() {
      this.$emit("toggledCompositionFields");
    },
    toggledDynamicFields() {
      this.$emit("toggledDynamicFields");
    },
    /*
    finds current category object
    category - current product category name (String)
    */
    async setCategoryFields(category) {
      //if category includes footwear, then remove any materialFields
      this.showMaterialFields = true;

      if (this.category.includes("Footwear")) {
        this.materialFields = [];
        this.showMaterialFields = false;
      }

      //category root name, ex. 'Clothes'
      let parentName = "";
      parentName = category.split("/")[0];
      //parent category object
      let parentCategory = this.categories.find(
        (element) => element.path == parentName
      );

      //current product category object
      let currentCategory = await this.searchCategoryTree(
        parentCategory,
        category
      );
      await this.getCategory(currentCategory.id);

      if (currentCategory.forUse || !currentCategory.forUse) {
        this.snackbarCat = false;
        //gets the category
        await this.getCategory(currentCategory.id);
      }
      //if category forUse is false, it means it cannot be selected when creating product
      else {
        this.snackbarText = "You cannot select this category.";
        this.snackbar = true;
        this.$emit("wrongCategory");
      }
    },
    /*
    finds category object by its name
    return category object if category is found
    else return null
    */
    searchCategoryTree(element, matchingPath) {
      if (element.path == matchingPath) {
        return element;
      } else if (element.children != null) {
        var i;
        var result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchCategoryTree(element.children[i], matchingPath);
        }
        return result;
      }
      return null;
    },
    //gets the category object by its id with all its configurations
    async getCategory(id) {
      try {
        const response = await this.$store.dispatch("getCategory", id);
        //set categoryIdPath value to sent it to backend (it uses it somewhere) it looks like : '01/001/0001'
        this.categoryIdPath = await response.data.data.idPath;

        //if configurations object exists in category object
        //then set category photo (measurements)
        if ("configurations" in response.data) {
          this.categoryImg =
            response.data.configurations.photos != undefined &&
              response.data.configurations.photos.length > 0
              ? response.data.configurations.photos[0]
              : "";
          //push configurations to custom arrays by purpose
          await this.formatFields(response.data.configurations.configurations);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
    push config fields to custom arrays by purpose
    configurations - category configurations object
    */
    /*
push config fields to custom arrays by purpose
configurations - category configurations object
*/
async formatFields(configurations) {
  // Clear existing arrays first to prevent duplication
  this.compositionConf = [
    {
      fieldType: "composition",
      name: "Material",
      purpose: "Composition",
      required: true,
    },
  ];
  this.measurementConf = [];
  this.sizeConf = [];
  this.otherConf = [];

  // Then populate with new data
  for (let i in configurations) {
    switch (configurations[i].purpose) {
      case "Composition":
        this.compositionConf.push(configurations[i]);
        break;
      case "Measurements":
        this.measurementConf.push(configurations[i]);
        break;
      case "Size":
        this.sizeConf.push(configurations[i]);
        break;
      case "Other":
        this.otherConf.push(configurations[i]);
        break;
    }
  }
  this.$emit("dynamicFieldsFilled");
},
    //validate composition, size, measurement, other fields
    fieldsValidation() {
      let validations = [];
      //if fields are opened in expansion panel
      if (this.$refs.sizeFields) {
        if (this.$refs.sizeFields.validateFields()) {
          validations.push("ok");
        } else {
          validations.push("bad");
        }
      }
      if (this.$refs.measurementFields) {
        if (this.$refs.measurementFields.validateFields()) {
          validations.push("ok");
        } else {
          validations.push("bad");
        }
      }
      if (this.$refs.otherFields) {
        if (this.$refs.otherFields.validateFields()) {
          validations.push("ok");
        } else {
          validations.push("bad");
        }
      }
      if (this.$refs.compositionFields) {
        if (this.$refs.compositionFields.compositionValidation()) {
          validations.push("ok");
        } else {
          validations.push("bad");
        }
      }
      if (validations.includes("bad")) {
        return false;
      } else {
        return true;
      }
    },
    //gets the data from all configured fields and pushes it to one array
    async getData() {
      let finalConfigured = [];
      if (this.compositionConf.length > 0) {
        finalConfigured.push(
          ...this.$refs.compositionFields.getCompositionData()
        );
      }
      if (this.sizeConf.length > 0) {
        finalConfigured.push(...(await this.$refs.sizeFields.getDataDynamic()));
      }
      if (this.measurementConf.length > 0) {
        finalConfigured.push(
          ...(await this.$refs.measurementFields.getDataDynamic())
        );
      }
      if (this.otherConf.length > 0) {
        finalConfigured.push(
          ...(await this.$refs.otherFields.getDataDynamic())
        );
      }

      return finalConfigured;
    },
    //emitted from parent when user selects gender
    async genderChanged(gender) {
      if (this.type == "registration") {
        this.categoryPanels = [0];
      } else {
        this.categoryPanels = [0, 1, 2, 3];
      }
      // this.$refs.sizeFields.formatFields();
      //re-render size fields component
      // await this.sizeKey++;

      //if gender is unisex then emit method which duplicates
      if (gender == "Unisex" && this.category.includes("Footwear")) {
        this.$refs.sizeFields.genderUnisex(gender);
      }
    },
  },
};
</script>